export default __webpack_public_path__ + "media/src/assets/images/WhiteArrow-65dfa6ddb76c3952c844564197c4e81b.png";